<template>
  <GeneralDialog v-model:visible="visible">
    <div class="w-full flex flex-col gap-7.5 p-3.75">
      <div class="flex items-center justify-between">
        <h3 :class="$typo.openSansBold14" class="text-text">
          {{ t(titleKey) }}
        </h3>
        <button class="flex items-center justify-center cursor-pointer text-text" @click="onCancel">
          <IconCustom ligature="close" size="16" />
        </button>
      </div>
      <p :class="$typo.openSans12" class="text-text-muted whitespace-pre-line">
        {{ t(introKey) }}
      </p>
      <ul class="flex flex-col gap-3.75">
        <li
          v-for="release in releases"
          :key="release.id"
          :class="$typo.openSans14"
          class="bg-button text-text rounded-[10px] px-3.75 py-2.5"
        >
          {{ release.label }}
        </li>
      </ul>
      <p :class="$typo.openSans12" class="text-text-muted">
        {{ t(footerKey) }}
      </p>
      <div class="flex gap-2.5 justify-between">
        <Button @click="onConfirm" :class="$typo.openSans12">
          <IconCustom ligature="add" size="16" />
          {{ t('bundleSpanAddConfirm') }}
        </Button>
        <Button @click="onCancel" :class="$typo.openSans12">
          <IconCustom ligature="close" size="16" />
          {{ t('collectionModalBulkEditCancel') }}
        </Button>
      </div>
    </div>
  </GeneralDialog>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import $typo from '@/styles/typografy.module.css'
import { useLocalizationStore, type TranslationKey } from '@/stores/localization.ts'
import GeneralDialog from '@/components/GeneralDialog.vue'
import Button from '@/components/Button.vue'
import IconCustom from '@/components/IconCustom.vue'

export type BundleAddRelease = {
  id: string
  label: string
}

const { t } = useLocalizationStore()

const props = defineProps<{
  releases: BundleAddRelease[]
  isBundle: boolean
}>()

const titleKey = computed<TranslationKey>(() =>
  props.isBundle ? 'bundleSpanAddTitleBundle' : 'bundleSpanAddTitleSlipcase',
)
const introKey = computed<TranslationKey>(() =>
  props.isBundle ? 'bundleSpanAddIntroBundle' : 'bundleSpanAddIntroSlipcase',
)
const footerKey = computed<TranslationKey>(() =>
  props.isBundle ? 'bundleSpanAddFooterBundle' : 'bundleSpanAddFooterSlipcase',
)

const visible = defineModel('visible', { default: false })

const emit = defineEmits<{
  (e: 'confirm'): void
}>()

const onCancel = () => {
  visible.value = false
}

const onConfirm = () => {
  visible.value = false
  emit('confirm')
}
</script>
